/* Lots GuardoPro : l'appareil offert devient une vraie ligne a 0 EUR.

   Kaching n'envoie dans le panier que la quantite PAYEE. L'appareil offert
   n'existe que dans une propriete technique __kaching_bundles, que Shopify
   masque. Resultat : la commande affiche  x 2 , et la preparation expedie
   deux appareils au lieu de trois.

   Principe : on n'essaie pas d'intercepter chaque action du client ni chaque
   evenement de l'appli. A chaque modification du panier, on relit le panier,
   on recalcule ce qui devrait s'y trouver, et on corrige. Cette approche
   couvre d'office le changement de palier, la modification de quantite, la
   suppression de la ligne payante et le panier repris d'une session passee.

   Le produit offert est un produit distinct a 0,00 EUR : Shopify ne permet
   pas de fixer un prix depuis la boutique, seul le prix de la variante
   compte. */

(function () {
  'use strict';

  var VARIANTE_OFFERTE = 57998374928764; // GuardoPro — Dispositivo in omaggio

  /* Le nombre d'offerts se deduit de la QUANTITE PAYEE, pas du palier Kaching.
     Mesure sur la boutique : quand le client change la quantite dans le panier,
     Kaching ne recalcule rien — le prix unitaire reste 29,90 et l'identifiant de
     palier reste fige sur celui de l'ajout. S'y fier donnait 4 appareils a
     quelqu'un qui paie 89,70, le prix du lot de 6.

     payes -> offerts, d'apres les paliers affiches sur la fiche :
       1 paye  -> 0 offert  (1 dispositivo)
       2 payes -> 1 offert  (Prendi 3 paghi 2)
       3 payes -> 3 offerts (Prendi 6 paghi 3)
       4 payes -> 5 offerts (Prendi 9 paghi 4) */
  var PALIERS = { 1: 0, 2: 1, 3: 3, 4: 5 };
  var PLUS_GRAND = 4; // au-dela, on compose des lots de 4 payes

  function offertsPour(quantite) {
    if (quantite <= 0) return 0;
    var lots = Math.floor(quantite / PLUS_GRAND);
    var reste = quantite % PLUS_GRAND;
    return lots * PALIERS[PLUS_GRAND] + (PALIERS[reste] || 0);
  }

  var occupe = false; // evite que nos propres appels se declenchent en cascade
  var sale = false; // une modification est arrivee pendant une reconciliation

  function lePanier() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function poste(url, corps) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corps),
    }).then(function (r) {
      return r.json();
    });
  }

  /* Combien d'appareils offerts le panier devrait contenir, d'apres les
     paliers portes par les lignes payantes. Une quantite multiple du palier
     compte autant de lots. */
  function offertsAttendus(panier) {
    var payes = 0;
    panier.items.forEach(function (ligne) {
      if (ligne.variant_id === VARIANTE_OFFERTE) return;
      // seules les lignes passees par le widget de lots ouvrent droit a un offert
      if (!ligne.properties || !ligne.properties.__kaching_bundles) return;
      payes += ligne.quantity;
    });
    return offertsPour(payes);
  }

  function ligneOfferte(panier) {
    var trouvee = null;
    panier.items.forEach(function (l) {
      if (l.variant_id === VARIANTE_OFFERTE) trouvee = l;
    });
    return trouvee;
  }

  /* Renvoie true si le panier a ete modifie, donc s'il faut le rafraichir. */
  function reconcilier() {
    if (occupe) return Promise.resolve(false);
    occupe = true;
    return lePanier()
      .then(function (panier) {
        var attendu = offertsAttendus(panier);
        var ligne = ligneOfferte(panier);
        var actuel = ligne ? ligne.quantity : 0;
        if (attendu === actuel) return false;
        // on demande le rendu du tiroir dans la meme requete : un aller-retour
        // au lieu de deux, c'est la moitie du delai percu
        var sections = 'cart-drawer,cart-icon-bubble';
        if (!ligne) {
          return poste('/cart/add.js', {
            items: [{ id: VARIANTE_OFFERTE, quantity: attendu }],
            sections: sections,
          }).then(function (r) {
            return r && r.sections ? r.sections : true;
          });
        }
        // quantity: 0 supprime la ligne — c'est le cas  plus aucun lot
        return poste('/cart/change.js', {
          id: ligne.key,
          quantity: attendu,
          sections: sections,
        }).then(function (r) {
          return r && r.sections ? r.sections : true;
        });
      })
      .then(function (change) {
        occupe = false;
        return change;
      })
      .catch(function () {
        occupe = false;
        return false;
      });
  }

  /* Une modification arrivee pendant une reconciliation etait perdue : le client
     qui cliquait vite sur  -  se retrouvait avec l'article offert fige sur la
     valeur precedente. On rejoue donc tant que le panier bouge. */
  function reconcilierJusquaStable(restant) {
    if (restant === undefined) restant = 4;
    return reconcilier().then(function (change) {
      if (restant > 0 && (sale || change)) {
        sale = false;
        return reconcilierJusquaStable(restant - 1).then(function (suite) {
          return change || suite;
        });
      }
      return change;
    });
  }

  function remplace(selectorCible, html, selectorSource) {
    if (!html) return;
    var cible = document.querySelector(selectorCible);
    if (!cible) return;
    var source = new DOMParser().parseFromString(html, 'text/html').querySelector(selectorSource);
    if (source) cible.innerHTML = source.innerHTML;
  }

  /* Rafraichit le tiroir sans l'ouvrir : renderContents() du theme appelle
     open() a la fin, ce qu'on ne veut pas au chargement d'une page. */
  function rafraichit() {
    return fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        remplace('#CartDrawer', sections['cart-drawer'], '#CartDrawer');
        remplace('#cart-icon-bubble', sections['cart-icon-bubble'], '.shopify-section');
      })
      .catch(function () {});
  }

  /* La ligne offerte ne doit etre ni cliquable, ni modifiable, ni supprimable :
     la reconciliation la remettrait, ce qui passerait pour un bug. En echange
     elle affiche sa quantite en clair, puisque le selecteur est masque. */
  function habille(li) {
    li.classList.add('gp-ligne-offerte');

    Array.prototype.forEach.call(li.querySelectorAll('a[href]'), function (a) {
      a.removeAttribute('href');
    });

    /* On reutilise l'emplacement du badge de la ligne payante : meme position,
       meme rythme vertical. */
    var badge = li.querySelector('.scd-hot');
    if (!badge) {
      badge = document.createElement('p');
      badge.className = 'scd-hot';
      var corps = li.querySelector('.scd-body');
      if (corps) corps.insertBefore(badge, corps.firstChild);
    }
    if (badge && badge.textContent.indexOf('omaggio') === -1) {
      badge.textContent = '\uD83C\uDF81 In omaggio';
    }

    /* La quantite, lue sur le selecteur masque. */
    var champ = li.querySelector('quantity-input input, .quantity__input');
    var n = champ ? parseInt(champ.value, 10) : 0;
    if (!n) n = 1;
    var q = li.querySelector('.gp-qte');
    if (!q) {
      q = document.createElement('span');
      q.className = 'gp-qte';
      var rang = li.querySelector('.scd-row') || li.querySelector('.scd-body');
      if (rang) rang.insertBefore(q, rang.firstChild);
    }
    if (q) q.textContent = '\u00D7 ' + n;
  }

  /* L'article offert remonte avant l'article paye dans le panier. On le remet
     en dernier UNIQUEMENT par CSS.

     Ne jamais deplacer le noeud : le tiroir est un formulaire dont les champs
     de quantite s'appellent updates[] et que Shopify applique PAR POSITION.
     Reordonner le DOM faisait partir  ligne 1 = 2, ligne 2 = 1  sur un panier
     ou la ligne 1 est l'article offert : le client payait un appareil et en
     recevait trois. */
  function ordonne() {
    var listes = document.querySelectorAll('.scd-items');
    Array.prototype.forEach.call(listes, function (liste) {
      liste.style.display = 'flex';
      liste.style.flexDirection = 'column';
      Array.prototype.forEach.call(liste.children, function (li) {
        li.style.order = li.classList.contains('gp-ligne-offerte') ? '2' : '1';
      });
    });
  }

  function neutralise() {
    var lignes = document.querySelectorAll('.cart-item');
    Array.prototype.forEach.call(lignes, function (li) {
      if (!li.querySelector('a[href*="variant=' + VARIANTE_OFFERTE + '"]')) return;
      habille(li);
    });
    ordonne();
  }

  function style() {
    if (document.getElementById('gp-lot-offert-style')) return;
    var s = document.createElement('style');
    s.id = 'gp-lot-offert-style';
    s.textContent =
      '.gp-ligne-offerte .scd-qty,' +
      '.gp-ligne-offerte quantity-input,' +
      '.gp-ligne-offerte cart-remove-button { display: none !important; }' +
      '.gp-ligne-offerte .scd-name,' +
      '.gp-ligne-offerte .scd-media { cursor: default; pointer-events: none; }' +
      /* le badge reprend la place de celui de la ligne payante, en vert */
      '.gp-ligne-offerte .scd-hot { display: block !important; color: #1E7A46 !important; }' +
      '.gp-qte { font-weight: 600; color: inherit; opacity: .75; }';
    document.head.appendChild(s);
  }

  var dernierNombre = null; // pour savoir si le panier vient de se vider

  /* Le theme gere la classe is-empty dans sa propre methode de rendu, qu'on
     court-circuite : sans elle, un tiroir vide s'affiche tout blanc. */
  function etatVide() {
    var tiroir = document.querySelector('cart-drawer');
    var inner = document.querySelector('.drawer__inner');
    if (!tiroir && !inner) return false;
    var vide = !document.querySelector('.scd-items .cart-item');
    // le theme porte is-empty sur l'element cart-drawer ; Dawn la lit aussi sur
    // .drawer__inner. On tient les deux a jour, sinon le message  panier vide
    // reste masque et le tiroir s'affiche blanc.
    if (tiroir) tiroir.classList.toggle('is-empty', vide);
    if (inner) inner.classList.toggle('is-empty', vide);
    return vide;
  }

  /* Retirer le dernier article laissait un panneau blanc ouvert : on ferme. */
  function fermeSiVide() {
    var vide = etatVide();
    if (!vide) {
      dernierNombre = document.querySelectorAll('.scd-items .cart-item').length;
      return;
    }
    var tiroir = document.querySelector('cart-drawer');
    // on ne ferme que si le panier vient de se vider, pas s'il l'etait deja :
    // sinon le client qui ouvre un panier vide le verrait se refermer aussitot
    if (tiroir && tiroir.classList.contains('active') && dernierNombre) {
      if (typeof tiroir.close === 'function') tiroir.close();
      else tiroir.classList.remove('active');
    }
    dernierNombre = 0;
  }

  function peint(sections) {
    remplace('#CartDrawer', sections['cart-drawer'], '#CartDrawer');
    remplace('#cart-icon-bubble', sections['cart-icon-bubble'], '.shopify-section');
  }

  function apresChangement() {
    return reconcilierJusquaStable().then(function (change) {
      if (change && typeof change === 'object') {
        // les sections sont arrivees avec la reponse : rien de plus a demander
        peint(change);
        neutralise();
        fermeSiVide();
        return;
      }
      if (change) {
        return rafraichit().then(function () {
          neutralise();
          fermeSiVide();
        });
      }
      neutralise();
      fermeSiVide();
    });
  }

  /* On ecoute les appels au panier plutot que les evenements du theme : une
     appli tierce qui ajoute au panier sans emettre d'evenement passerait
     autrement inapercue. */
  /* Le widget de lots poste un FormData (id, quantity, properties[...]).
     On le retranscrit en JSON en y ajoutant l'article offert, pour que tout
     parte dans un seul appel : le tiroir s'ouvre deja complet au lieu de se
     recomposer une seconde plus tard. Les proprietes du widget sont
     conservees telles quelles, c'est elles qui portent son offre.
     Renvoie null si on ne reconnait pas le corps : la reconciliation prend
     alors le relais comme avant. */
  function injecteOffert(body) {
    var article = { properties: {} };
    try {
      if (body instanceof FormData) {
        body.forEach(function (valeur, cle) {
          var m = cle.match(/^properties\[(.+)\]$/);
          if (m) article.properties[m[1]] = valeur;
          else if (cle === 'id') article.id = Number(valeur);
          else if (cle === 'quantity') article.quantity = Number(valeur);
        });
      } else if (typeof body === 'string') {
        var j = JSON.parse(body);
        if (j.items) return null; // deja au bon format, rien a faire ici
        article.id = Number(j.id);
        article.quantity = Number(j.quantity) || 1;
        article.properties = j.properties || {};
      } else {
        return null;
      }
    } catch (e) {
      return null;
    }

    if (!article.id || article.id === VARIANTE_OFFERTE) return null;
    var offerts = offertsPour(article.quantity || 1);
    if (offerts <= 0) return null;

    return JSON.stringify({
      items: [article, { id: VARIANTE_OFFERTE, quantity: offerts }],
      sections: 'cart-drawer,cart-icon-bubble',
    });
  }

  var fetchOrigine = window.fetch;
  window.fetch = function (ressource, options) {
    var url = typeof ressource === 'string' ? ressource : (ressource && ressource.url) || '';
    var estPanier = /\/cart\/(add|change|update|clear)/.test(url);

    /* L'article offert part dans la requete d'ajout du widget de lots, au lieu
       d'un appel separe ensuite : le tiroir s'ouvre deja complet. La
       reconciliation reste la source de verite et corrige si l'estimation
       etait fausse (panier deja garni, par exemple). */
    if (!occupe && /\/cart\/add/.test(url) && options && options.body) {
      var injecte = injecteOffert(options.body);
      if (injecte) {
        options = Object.assign({}, options, {
          body: injecte,
          headers: Object.assign({}, options.headers || {}, {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          }),
        });
        arguments[1] = options;
      }
    }

    var promesse = fetchOrigine.apply(this, arguments);
    if (!estPanier) return promesse;
    if (occupe) {
      // concurrence : on note qu'il faudra repasser, au lieu d'ignorer
      sale = true;
      return promesse;
    }
    return promesse.then(function (reponse) {
      apresChangement();
      return reponse;
    });
  };

  /* Dernier filet : quoi qu'il arrive en amont, on remet le panier d'aplomb
     avant de laisser partir au paiement. */
  function barriereCheckout() {
    document.addEventListener(
      'click',
      function (e) {
        var cible =
          e.target.closest &&
          e.target.closest(
            '[name="checkout"], a[href*="/checkout"], .scd-checkout,' +
              // portefeuilles express : ils filent au paiement sans passer par le panier
              ' shopify-accelerated-checkout, .shopify-payment-button__button,' +
              ' [data-shopify="payment-button"], form[action*="/checkout"] button'
          );
        if (!cible || cible.dataset.gpVerifie) return;
        e.preventDefault();
        e.stopPropagation();
        reconcilierJusquaStable().then(function () {
          cible.dataset.gpVerifie = '1';
          cible.click();
        });
      },
      true
    );
  }

  function demarre() {
    style();
    neutralise();
    barriereCheckout();
    apresChangement();
    var tiroir = document.querySelector('cart-drawer');
    if (tiroir && window.MutationObserver) {
      // le theme remplace l'interieur du tiroir : on reapplique apres chaque rendu
      new MutationObserver(neutralise).observe(tiroir, { childList: true, subtree: true });
    }
  }

  /* Un panier peut avoir ete fausse ailleurs : autre onglet, retour arriere,
     session laissee ouverte. On repasse dessus des que la page redevient
     active, pas seulement au chargement. */
  window.addEventListener('pageshow', apresChangement);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) apresChangement();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarre);
  } else {
    demarre();
  }
})();
